import {
  V2ListWebhookSubscriptionsForAccountApiArg,
  useV2ListWebhookSubscriptionsForAccountQuery,
} from "@generated";
import type { WebhookSubscription } from "../types";

export interface UseWebhookSubscriptionsListArgs {
  page?: V2ListWebhookSubscriptionsForAccountApiArg["page"];
}

export const useWebhookSubscriptionsList = ({
  page,
}: UseWebhookSubscriptionsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListWebhookSubscriptionsForAccountQuery(
      { page },
      { refetchOnMountOrArgChange: true }
    );

  const rows: WebhookSubscription[] = (data?.data ?? []).map((sub) => ({
    id: String(sub.id),
    webhookUrl: sub.attributes?.["webhook-url"] ?? "",
    eventType: sub.attributes?.["event-type"] ?? "",
  }));

  const pageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};
